var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-declining-large.73616b74.png","uri@2x": __webpack_public_path__ + "icon-declining-large.7ecda245.png","uri@3x": __webpack_public_path__ + "icon-declining-large.2a020a42.png",
    width: 100,
    height: 100
});